import script from "./CancelOrder.vue?vue&type=script&setup=true&lang=ts"
export * from "./CancelOrder.vue?vue&type=script&setup=true&lang=ts"

import "./CancelOrder.vue?vue&type=style&index=0&id=71607086&lang=scss"

const __exports__ = script;

export default __exports__